import { cn } from "@/utils/cn";
import { memo } from "react";
import { SwapPlanAdjustmentIllustration } from "./swap-plan-adjustment-illustration";

interface SwapPlanAdjustmentHeroProps {
  className?: string;
}

export const SwapPlanAdjustmentHero = memo(function SwapPlanAdjustmentHero({
  className,
}: SwapPlanAdjustmentHeroProps) {
  return (
    <div className={cn("relative aspect-square max-h-[308px] w-full", className)}>
      <div
        className="h-full w-full blur-2xl"
        style={{
          backgroundImage: "url('/assets/images/aura.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <div className="absolute inset-0 mx-auto my-auto flex items-center justify-center">
        <SwapPlanAdjustmentIllustration />
      </div>
    </div>
  );
});
